/*
Selenium injects variables to the global `window` and `document` object that match the regex below

examples:
'$cdc_asdjflasutopfhvcZLmcfl_',
'cdc_adoQpoasnfa76pfcZLmcfl_Array',
'cdc_adoQpoasnfa76pfcZLmcfl_Promise',
'cdc_adoQpoasnfa76pfcZLmcfl_Symbol'
*/

const isRunningInSelenium = (): boolean => {
  const windowKeys = Object.keys(window);
  const documentKeys = Object.keys(window.document);

  return Boolean(windowKeys.concat(documentKeys).find((key) => key.match(/^\$?[a-z]dc_/)));
};

export default isRunningInSelenium;
